import queryString from 'query-string';

export const getRedirectBase = url => {
  const trimmed = url.endsWith('/') ? url.slice(0, -1) : url;

  return trimmed;
};

export const getRedirectUrlPath = (pathArray, payment, product) =>
  pathArray
    .map(path => {
      try {
        if (path.key === 'coupon') {
          if (!payment.coupon?.code) {
            return '';
          }

          return payment.coupon.code;
        }

        if (path.key === 'orderId') {
          return payment.orderId;
        }

        if (path.key === 'stripeCustomerId') {
          return payment.customer?.stripeCustomerId;
        }

        if (path.key === 'stripePaymentId') {
          return payment.stripePaymentIntentId;
        }

        if (path.key === 'stripeSubscriptionId') {
          return payment?.subscriptionId;
        }

        if (path.key === 'fields') {
          const field = payment[path.key].find(el => el.fieldId === path.identifier);

          if (!field) return '';

          return field.value;
        }

        if (path.key === 'variants') {
          const variant = payment[path.key].find(el => el.variantId === path.identifier);

          if (!variant) return '';

          const productVariant = product.variants.find(v => v._id === path.identifier);

          const variantOption = productVariant.options?.find(
            vo => vo._id === variant.selectedOptionId,
          );

          if (!variantOption) return '';

          return variantOption.sku;
        }

        return '';
      } catch (err) {
        return '';
      }
    })
    .join('/');

export const getRedirectUrlQuery = (queryArray, payment, product) => {
  const queryString = queryArray
    .map((query, index) => {
      try {
        if (query.key === 'fields') {
          const field = payment[query.key].find(el => el.fieldId === query.identifier);

          if (!field) return '';

          return `${query.parameter}=${field.value}`;
        }

        if (query.key === 'variants') {
          const variant = payment[query.key].find(el => el.variantId === query.identifier);

          if (!variant) return '';

          const productVariant = product.variants.find(v => v._id === query.identifier);

          if (!productVariant) return '';

          const variantOption = productVariant.options?.find(
            vo => vo._id === variant.selectedOptionId,
          );

          if (!variantOption) return '';

          return `${query.parameter}=${variantOption.sku}`;
        }

        if (query.key === 'coupon') {
          if (!payment.coupon?.code) {
            return '';
          }

          return `${query.parameter}=${payment.coupon.code}`;
        }

        if (query.key === 'orderId') {
          return `${query.parameter}=${payment.orderId}`;
        }

        if (query.key === 'stripeCustomerId') {
          return `${query.parameter}=${payment.customer?.stripeCustomerId}`;
        }

        if (query.key === 'stripePaymentId') {
          return `${query.parameter}=${payment.stripePaymentIntentId}`;
        }

        if (query.key === 'stripeSubscriptionId') {
          return `${query.parameter}=${payment?.subscriptionId}`;
        }

        return '';
      } catch (err) {
        return '';
      }
    })
    .filter(Boolean)
    .join('&');

  return queryString ? `?${queryString}` : '';
};

/**
 * returns a user-defined URL with user-defined path and query parameters based on the payment
 * used for redirect-after-payment and redirect-after-upsell actions
 */
export default function getRedirectUrl({
  searchParams = {},
  iframeId,
  url = '',
  path = [],
  query = [],
  payment = {},
  product = { variants: [] },
}) {
  let redirectUrl = getRedirectBase(url);

  const redirectPath = getRedirectUrlPath(path, payment, product);

  if (redirectPath) {
    redirectUrl = `${url}/${redirectPath}`;
  }

  let redirectQuery = getRedirectUrlQuery(query, payment, product);

  if (searchParams) {
    delete searchParams['payment_intent'];
    delete searchParams['payment_intent_client_secret'];
    delete searchParams['redirect_status'];

    const parsedQuery = queryString.stringify(searchParams);

    // add parsed query to redirect url
    if (parsedQuery) {
      if (redirectUrl.includes('?')) {
        redirectUrl = `${redirectUrl}&${parsedQuery}`;
      } else {
        redirectUrl = `${redirectUrl}?${parsedQuery}`;
      }
    }
  }

  if (redirectQuery) {
    if (redirectUrl.includes('?')) {
      const qs = redirectQuery.split('?').join('&');
      redirectUrl = `${redirectUrl}${qs}`;
    } else {
      redirectUrl = `${redirectUrl}${redirectQuery}`;
    }
  }

  if (iframeId) {
    if (redirectUrl.includes('?')) {
      redirectUrl = `${redirectUrl}&iframeId=${iframeId}`;
    } else {
      redirectUrl = `${redirectUrl}?iframeId=${iframeId}`;
    }
  }

  if (redirectUrl.endsWith('/')) {
    redirectUrl = redirectUrl.substring(0, redirectUrl.length - 1);
  }

  return redirectUrl;
}
